import { Injectable } from '@angular/core';
import { WorkspaceStateManagerService } from '../../workspace/state-management/workspace-state-manager.service';
import { OrganizationStateManagerService } from '../../organization/state-management/organization-state-manager.service';

@Injectable()
export class OrganWsShardStateService {
    public currentOrgan$ = this.organStateService.currentOrganization$;
    public currentWS = this.workspaceState.currentWorkspace$;

    public currentWSId$ = this.workspaceState.currentWorkspaceId$;
    public currentOrganId$ = this.organStateService.currentOrganId$;
    constructor(
        private organStateService: OrganizationStateManagerService,
        private workspaceState: WorkspaceStateManagerService
    ) {}
}
